/* eslint-disable react/prop-types */
// PlantCircle.jsx
import React from 'react'

export const PlantCircle = ({ height, width, style }) => {
  const svgStyle = { ...style }
  return (
    <svg
      style={svgStyle}
      viewBox='0 0 75 75'
    >
      <description>plant circle icon</description>
      <title>plant circle</title>
      <g
        style={{
          transform: 'translate(7px, 7px) scale(2)',
        }}
      >
        <path d='M15,0C6.709,0 0,6.933 0,15.5C0,24.067 6.709,31 15,31C23.291,31 30,24.067 30,15.5C30,6.933 23.291,0 15,0ZM15,2.971C21.709,2.971 27.125,8.567 27.125,15.5C27.125,22.433 21.709,28.029 15,28.029C8.291,28.029 2.875,22.433 2.875,15.5C2.875,8.567 8.291,2.971 15,2.971Z' />
        <g transform='matrix(1,0,0,1,3.97665,4.65468)'>
          <path d='M3.14,15.658C5.201,17.788 7.884,18.382 9.466,18.53L9.466,22.195L12.341,22.195L12.341,18.53C13.875,18.382 16.559,17.837 18.571,15.807C21.638,12.885 21.734,8.379 21.734,7.883L21.734,6.497L20.345,6.398C19.482,6.348 17.421,6.398 15.36,7.289C14.785,3.922 12.581,1.545 12.054,1.05L11.095,0.158L10.137,1.05C9.61,1.495 7.357,3.922 6.782,7.24C4.578,6.2 2.421,6.15 1.75,6.15L0.408,6.249L0.313,7.586L0.313,7.685C0.313,8.824 0.408,12.836 3.14,15.658ZM9.514,9.072L9.514,8.725C9.562,6.844 10.472,5.209 11.143,4.367C11.862,5.407 12.677,6.992 12.677,8.775L12.677,9.022L12.629,9.072C11.958,9.716 11.431,10.459 11.095,11.102C10.616,10.36 10.089,9.666 9.514,9.072ZM5.249,13.479C4.051,12.241 3.571,10.508 3.38,9.221C4.626,9.419 6.303,9.914 7.501,11.152C8.795,12.489 9.274,14.321 9.418,15.46C8.316,15.312 6.543,14.866 5.249,13.479ZM12.533,15.51C12.868,13.677 13.539,12.291 14.594,11.251C15.84,10.013 17.565,9.567 18.763,9.419C18.571,10.558 18.044,12.34 16.75,13.628C15.408,14.915 13.683,15.361 12.533,15.51Z' />
        </g>
      </g>
    </svg>
  )
}

const PlantCircleDefault = ({ style }) => <PlantCircle style={{ fill: '#a0ccff', ...style }} />

export default PlantCircleDefault
